import { render } from "./NavButton.vue?vue&type=template&id=86f604b8&scoped=true"
import script from "./NavButton.vue?vue&type=script&lang=js"
export * from "./NavButton.vue?vue&type=script&lang=js"

import "./NavButton.vue?vue&type=style&index=0&id=86f604b8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f604b8"]])

export default __exports__